import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HubNotificationService } from '@app/core/services/Common/hubnotification.service';
import { LifeQuotationService } from '@app/core/services/life/quotation/quotation.service';
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { confirm } from 'devextreme/ui/dialog';
declare var bootstrap: any; // Declare Bootstrap to avoid TypeScript errors
import { DxPopupModule } from 'devextreme-angular';

@Component({
  selector: 'hub-notification',
  templateUrl: './hubnotification.component.html',
  styleUrls: ['./hubnotification.component.css'],
  providers: [LifeQuotationService, HubNotificationService],
})
export class HubNotificationComponent implements OnInit, AfterViewInit, OnDestroy {
  unreadCount = 0;
  lifeRole: any;
  notifications: any;
  @ViewChild('liveToast') liveToast: ElementRef;
  @ViewChild('list') list: ElementRef;
  toastInstance: any;
  isPopupVisible: boolean = false;
  quotationData: any = {}; // Placeholder for actual data

  unreadNotification: any = {};
  popupToolbar: { widget: string; toolbar: string; location: string; options: { text: string; type: string; onClick: () => void; }; }[];
  constructor(
    private hubnotificationService: HubNotificationService,
    private lifeService: LifeQuotationService,
    private authService: AuthService,
    private router: Router,
    private loaderService: NgxUiLoaderService,
  ) {


    this.popupToolbar = [
      {
        widget: 'dxButton',
        toolbar: 'bottom',
        location: 'center',
        options: {
          text: 'Yes',
          type: 'warning',
          onClick: () => this.createLifeQuote()
        }
      },
      {
        widget: 'dxButton',
        toolbar: 'bottom',
        location: 'center',
        options: {
          text: 'No',
          type: 'warning',
          onClick: () => this.isPopupVisible = false
        }
      }
    ];
  }
  ngAfterViewInit() {
    this.toastInstance = new bootstrap.Toast(this.liveToast.nativeElement, { delay: 10000 });
  }
  ngOnInit() {
    this.quotationData = {};
    this.loadSource();
    this.hubnotificationService.getNotifications().subscribe((newNotifications) => {
      //this.notifications._items.push(notificationsRes);
      this.unreadCount = newNotifications.filter(n => !n.isRead).length;
      this.unreadNotification = Array.isArray(newNotifications) ? newNotifications[0] : newNotifications;
      this.toastInstance?.show();
      if (newNotifications.length > 0) {
        const currentData = this.notifications.items();  // 'notifications' is your DevExtreme DataSource
        // Add the new notifications to the current data
        const updatedData = [...currentData, ...newNotifications[0]];
        // Update the items in the DataSource
        this.notifications.items(updatedData);

      }
    });
  }
  loadSource() {
    this.notifications = this.hubnotificationService.getHealthLifeNotificationsDataStore();
  }
  trackBySourceQuotationId(index: number, notification: any): any {
    return notification.quotationId;
  }
  viewNotification(notification: any) {
    // this.showPopup();
    // return;
    notification.isRead = true;
    this.unreadCount = this.notifications._items.filter(n => !n.isRead).length;
    this.loaderService.start();
    this.lifeService.getHealthLifeQuotationDetail(notification.quotationId)
      .subscribe(result => {
        this.loaderService.stop();
        if (result.success) {
          this.quotationData = result.data;
          this.quotationData.source = notification.source;
          this.quotationData.quotationId = notification.quotationId;
          this.showPopup();
        }
      }, (error) => {
        notify({ message: error.message, width: 500, shading: false }, 'Error', 3000);
        this.loaderService.stop();
      });
  }

  showPopup() {
    this.isPopupVisible = true;
  }

  test() {
    this.quotationData = {
      quotationNo: 'AE/2025000094/1',
      optionId: 1,
      groupSize: 1,
      source: 'Health',
      quotationId: 12121,
      createdDate: '2025-02-06',
      inceptionDate: '2025-03-01',
      policyHolderName: 'John Doe Inc.',
      createdByName: 'Nouman.',
      externalStatusId: 1,
      isQuoted: true,
    };
    this.notifications._items.push(this.quotationData);

  }

  createLifeQuote() {
    this.qetQuotation(this.quotationData.quotationId, this.quotationData.source);
  }


  qetQuotation(sourceQuotationId: any, source: any) {
    if (source === "Health") {
      this.loaderService.start();
      this.lifeService.getHealthLifeQuotation(sourceQuotationId)
        .subscribe(result => {
          this.loaderService.stop();
          if (result.data.statusId === 1) {
            this.isPopupVisible = false;
            this.router.navigate([`/quote/life/${this.authService.tenantCode}/policyholder`], { state: { quotationId: result.data.quotationId, mode: 'EDIT', optionId: 1 } });
          }
          if (result.data.statusId !== 1) {

            this.quotationData.quotedMessage = 'Quote has already been issued to this policy holder ' + result.data.policyHolder + ', you will have to create a new option if any modifications are required!';
            //this.popupToolbar.splice(0,1);
          }
        },
          error => {
            this.loaderService.stop();

            if (error.status === 400) {
              notify({ message: "Error while preparing the quotation, please try again later!", width: 300, shading: false }, "Error", 3000);
            }
            if (error.status === 0) {
              notify({ message: "Network error while reaching the server. Please check your network connection! ", width: 300, shading: false }, "Error", 3000);
            }
          });
    }
  }

  ngOnDestroy(): void {
  }
}

